import React, { useEffect, useState } from 'react';

import { hasRoles, CREATE_PARTICIPANT_REVIEW_ROLES } from '../../../../util/RoleUtil';

import { retrieveReviews } from '../../../../services/ReviewService';

import { Table } from '../../../common/table/Table';

import './ParticipantReviewSearch.css';

export const ParticipantReviewSearch = ({ navigateTo, navigateToWith, context, setSpinnerText, showToaster }) => {
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setSpinnerText('Retrieving Reviews');
      const [data, error] = await retrieveReviews(context.username);
      if (data) {
        if (data.responseStatus === 'Success') {
          setSearchResults(data.viewAllReviewVOs);
          showToaster({
            responseStatus: 'Success',
            responseMessage: 'Reviews successfully retrieved.',
          });
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }
      setSpinnerText(null);
    };
    fetchData();
  }, [setSpinnerText, context, setSearchResults, showToaster]);

  if (!searchResults) return null;

  const handleRowClick = (review) => {
    navigateToWith('participantReviewsEdit', 'participantReviewCreateGeneral', review);
  };

  const handleAddButtonClick = () => {
    navigateTo('participantReviewsCreate');
  };

  return (
    <div className="participant-review-search">
      <Table
        tableData={searchResults}
        hiddenColumns={['reviewExternalReference']}
        searchEnabled={true}
        filterEnabled={true}
        onRowClick={handleRowClick}
        tableTitle={'Participant Reviews'}
        buttonText={hasRoles(context, CREATE_PARTICIPANT_REVIEW_ROLES) ? 'Create New' : undefined}
        onButtonClick={handleAddButtonClick}
        buttonOneWidth={'135px'}
        maxRowCount={9}
        horizontalScroll
      />
    </div>
  );
};
